import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=2f0c4e42&"
import script from "./Tinymce.vue?vue&type=script&lang=js&"
export * from "./Tinymce.vue?vue&type=script&lang=js&"
import style0 from "./Tinymce.vue?vue&type=style&index=0&id=2f0c4e42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports